var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_28605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.326416,
    width: 33,
    height: 33,
    rx: 8,
    fill: "url(#paint0_linear_269_28605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1315 8.60575C25.7893 8.3491 26.4693 8.92466 26.3249 9.61573L23.3748 23.7169C23.237 24.3779 22.4604 24.6757 21.9159 24.2757L17.4626 21.0069L15.1926 23.3247C14.7937 23.7314 14.106 23.5658 13.9348 23.0235L12.2971 17.8246L7.90705 16.5279C7.33039 16.3579 7.29706 15.5557 7.85594 15.3368L25.1315 8.60575ZM22.9659 11.7346C23.1581 11.5646 22.9348 11.2646 22.717 11.4002L13.2414 17.2768C13.0748 17.3801 12.9981 17.5835 13.057 17.7712L14.3492 23.4457C14.3748 23.5324 14.4992 23.5201 14.5103 23.4302L14.7992 19.1057C14.8103 18.9991 14.8614 18.9013 14.9415 18.8302L22.9659 11.7346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7173 11.4001C22.935 11.2646 23.1584 11.5646 22.9662 11.7346L14.9418 18.8302C14.8618 18.9013 14.8107 18.999 14.7995 19.1057L14.5106 23.4301C14.4996 23.5201 14.3751 23.5324 14.3495 23.4457L13.0573 17.7712C12.9984 17.5835 13.0751 17.3801 13.2418 17.2768L22.7173 11.4001Z",
    fill: "#9EC2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3959 23.5047C14.187 23.4302 14.0104 23.2635 13.9348 23.0235L12.2971 17.8246L7.90705 16.5279C7.33039 16.3579 7.29706 15.5557 7.85594 15.3368L25.1314 8.60581C25.5559 8.44023 25.9903 8.62134 26.2048 8.95695C26.1648 8.89585 26.117 8.83919 26.0637 8.78918L14.3437 18.3569V18.7758L14.2792 18.7291L14.3437 21.3669V23.4825C14.3604 23.4903 14.3781 23.4969 14.3959 23.5025V23.5047H14.3959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4628 21.0069L15.1928 23.3247C15.174 23.3436 15.154 23.3625 15.1339 23.3792C15.114 23.3959 15.0939 23.4103 15.0728 23.4248C15.0717 23.4258 15.0717 23.4258 15.0717 23.4258C15.0295 23.4536 14.9862 23.477 14.9406 23.4958C14.9173 23.5047 14.8951 23.5136 14.8717 23.5192C14.7751 23.5481 14.6762 23.5559 14.5784 23.5459C14.5529 23.5437 14.5273 23.5392 14.5029 23.5348C14.4995 23.5348 14.4962 23.5337 14.4929 23.5326C14.4685 23.5259 14.444 23.5192 14.4195 23.5114C14.4117 23.5093 14.404 23.507 14.3962 23.5025L14.344 21.367V18.7759L17.4628 21.0069Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1349 23.3789C15.1146 23.3959 15.0942 23.4117 15.0728 23.4263V23.4252C15.0942 23.4106 15.1146 23.3959 15.1349 23.3789Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0736 23.4246V23.4263C15.0736 23.4263 15.0736 23.4246 15.0718 23.4263C15.0718 23.4263 15.0718 23.4263 15.0736 23.4246Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9404 23.4958C14.9862 23.4769 15.0296 23.4535 15.072 23.4256C15.0296 23.4534 14.985 23.4768 14.9404 23.4958Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5781 23.5458C14.6759 23.5559 14.7748 23.548 14.8715 23.5189C14.8015 23.5413 14.7292 23.5514 14.657 23.5514C14.6348 23.5514 14.6125 23.5503 14.5915 23.548C14.587 23.5481 14.5826 23.5481 14.5781 23.5458Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5791 23.5458C14.5836 23.548 14.588 23.548 14.5925 23.548C14.569 23.5469 14.5477 23.5435 14.5254 23.5389C14.5432 23.5424 14.5612 23.5446 14.5791 23.5458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.579 23.546C14.5611 23.5449 14.5432 23.5426 14.5253 23.5392C14.5175 23.5381 14.5097 23.537 14.5029 23.5347C14.5275 23.5392 14.5532 23.5438 14.579 23.546Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4192 23.5114C14.4438 23.5193 14.4685 23.526 14.4931 23.5328C14.483 23.5306 14.4729 23.5283 14.4629 23.5261C14.4584 23.525 14.4539 23.5239 14.4505 23.5216C14.4404 23.5193 14.4293 23.5159 14.4192 23.5114Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4624 23.5258C14.4723 23.528 14.4821 23.5302 14.492 23.5324C14.4821 23.5313 14.4723 23.5291 14.4624 23.5258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4198 23.5115C14.4301 23.5161 14.4415 23.5195 14.4518 23.5218C14.4346 23.5183 14.4175 23.5126 14.4004 23.5058C14.4072 23.508 14.4129 23.5104 14.4198 23.5115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.419 23.5113C14.4124 23.5102 14.4068 23.508 14.4002 23.5058C14.3991 23.5069 14.3968 23.5058 14.3958 23.5047V23.5025C14.4034 23.5069 14.4112 23.509 14.419 23.5113Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.344 21.3669L14.3967 23.5025C14.3787 23.4969 14.3608 23.4902 14.344 23.4825V21.3669Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3439 18.7758V21.3669L14.2788 18.7291L14.3439 18.7758Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9662 11.7347L14.9418 18.8303C14.8618 18.9013 14.8107 18.9991 14.7995 19.1058L14.5112 23.4306C14.5001 23.5206 14.3756 23.5328 14.3489 23.4461L13.0573 17.7714C12.9984 17.5836 13.0751 17.3803 13.2418 17.2769L22.7173 11.4003C22.9351 11.2647 23.1584 11.5647 22.9662 11.7347Z",
    fill: "#ADBCC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_28605",
    x1: 16.8264,
    y1: 0,
    x2: 16.8264,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AA5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_28605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0881958072c4221a25a25ba3e02a9540.svg";
export { ForwardRef as ReactComponent };